var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFieldArrayAdd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "radio_component"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20C4.47715 20 0 15.5228 0 10C0.00622974 4.47974 4.47974 0.00622974 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20ZM5.21739 8.69565C4.73714 8.69565 4.34783 9.08497 4.34783 9.56522V10.4348C4.34783 10.915 4.73714 11.3043 5.21739 11.3043H8.47826C8.59832 11.3043 8.69565 11.4017 8.69565 11.5217V14.7826C8.69565 15.2629 9.08497 15.6522 9.56522 15.6522H10.4348C10.915 15.6522 11.3043 15.2629 11.3043 14.7826V11.5217C11.3043 11.4017 11.4017 11.3043 11.5217 11.3043H14.7826C15.2629 11.3043 15.6522 10.915 15.6522 10.4348V9.56522C15.6522 9.08497 15.2629 8.69565 14.7826 8.69565H11.5217C11.4017 8.69565 11.3043 8.59832 11.3043 8.47826V5.21739C11.3043 4.73714 10.915 4.34783 10.4348 4.34783H9.56522C9.08497 4.34783 8.69565 4.73714 8.69565 5.21739V8.47826C8.69565 8.59832 8.59832 8.69565 8.47826 8.69565H5.21739Z",
    fill: "#2396DC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFieldArrayAdd);
export default __webpack_public_path__ + "static/media/field-array-add.ac97fc5f906a5cadce1338142471132d.svg";
export { ForwardRef as ReactComponent };